import { ReactNode } from "react";

import { Message, SnackbarSeverity } from "./Message";

export interface ShowOptions {
  /** Duration in milliseconds. Set to 0 for persistent (manual close only) */
  autoHideDuration?: number;
  messageId?: string;
}

export interface SnackbarMessage {
  message: ReactNode;
  severity: SnackbarSeverity;
  key: string;
  options?: ShowOptions;
}

interface MessagesProps {
  messages: SnackbarMessage[];
  autoHideDuration: number;
  onRemoveMessage: (key: SnackbarMessage["key"]) => void;
}

export const Messages = (props: MessagesProps) => {
  const { messages, autoHideDuration, onRemoveMessage } = props;

  const handleClose = (key: SnackbarMessage["key"]) => () =>
    onRemoveMessage(key);

  return messages.map((msg, index) => {
    const { key, message, severity, options } = msg;

    const perItemDuration = options?.autoHideDuration ?? autoHideDuration;
    const messageId = options?.messageId;

    return (
      <Message
        key={key}
        autoHideDuration={perItemDuration || undefined} // 0 must be converted to undefined to have the Snackbar persistent
        index={index}
        message={message}
        messageId={messageId}
        onClose={handleClose(key)}
        severity={severity}
      />
    );
  });
};
